(function () {
  if (window.VariantCombinations) return;

  function othersMatch(variantOptions, selectedOptions, optionIndex) {
    for (let j = 0; j < selectedOptions.length; j++) {
      if (j === optionIndex) continue;
      if (selectedOptions[j] == null) continue;
      if (variantOptions[j] !== selectedOptions[j]) return false;
    }
    return true;
  }

  function setRadioUnavailable(el, isHidden) {
    const wasHidden = el.classList.contains('combo-hidden');
    el.classList.toggle('combo-hidden', isHidden);
    if (isHidden === wasHidden) return;

    if (isHidden) {
      if (el.hasAttribute('name')) {
        el.dataset.optionName = el.getAttribute('name');
        el.removeAttribute('name');
      }
      el.disabled = true;
      el.tabIndex = -1;
    } else {
      if (el.dataset.optionName) {
        el.setAttribute('name', el.dataset.optionName);
      }
      el.disabled = false;
      el.removeAttribute('tabindex');
    }
  }

  function getOptionGroups(rootEl) {
    const selects = Array.from(rootEl.querySelectorAll('select'));
    if (selects.length) {
      return selects.map((select) => ({ type: 'select', valueEls: Array.from(select.options) }));
    }
    const fieldsets = Array.from(rootEl.querySelectorAll('fieldset'));
    return fieldsets.map((fieldset) => ({
      type: 'radio',
      valueEls: Array.from(fieldset.querySelectorAll('input[type="radio"]'))
    }));
  }

  window.VariantCombinations = {
    // Values for an option are constrained by the current selections of every
    // other option (full mutual filtering). Any value that cannot co-exist with
    // the other selected options is hidden, symmetrically across all groups.
    validValuesForOption(variantData, selectedOptions, optionIndex) {
      const exists = new Set();
      const available = new Set();
      variantData.forEach((variant) => {
        if (!variant.options) return;
        if (othersMatch(variant.options, selectedOptions, optionIndex)) {
          const value = variant.options[optionIndex];
          exists.add(value);
          if (variant.available) available.add(value);
        }
      });
      return { exists, available };
    },

    // Nearest existing variant, keeping the option the customer just changed
    // (pinnedIndex) so a change is never silently reverted.
    findNearest(variantData, selectedOptions, pinnedIndex) {
      let best = null;
      let bestScore = -1;

      variantData.forEach((variant) => {
        if (!variant.options) return;
        if (pinnedIndex != null && variant.options[pinnedIndex] !== selectedOptions[pinnedIndex]) return;

        let score = 0;
        variant.options.forEach((option, index) => {
          if (selectedOptions[index] === option) score += 1;
        });
        if (variant.available) score += 0.5;

        if (score > bestScore) {
          bestScore = score;
          best = variant;
        }
      });

      if (!best && pinnedIndex != null) {
        return this.findNearest(variantData, selectedOptions, null);
      }
      return best;
    },

    getChangedIndex(rootEl, target) {
      if (!target) return null;
      const selects = Array.from(rootEl.querySelectorAll('select'));
      if (selects.length) {
        const index = selects.indexOf(target.closest('select'));
        return index >= 0 ? index : null;
      }
      const fieldsets = Array.from(rootEl.querySelectorAll('fieldset'));
      const index = fieldsets.indexOf(target.closest('fieldset'));
      return index >= 0 ? index : null;
    },

    applyVariantToInputs(rootEl, variant) {
      if (!variant || !variant.options) return;
      const selects = Array.from(rootEl.querySelectorAll('select'));
      if (selects.length) {
        selects.forEach((select, index) => {
          if (variant.options[index] != null) select.value = variant.options[index];
        });
        return;
      }
      const fieldsets = Array.from(rootEl.querySelectorAll('fieldset'));
      fieldsets.forEach((fieldset, index) => {
        const targetValue = variant.options[index];
        fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = input.value === targetValue;
        });
      });
    },

    // Hides option values with no existing variant under the current selection,
    // and applies the sold-out treatment to existing-but-unavailable values.
    refreshVisibility(rootEl, variantData, referenceOptions, options) {
      if (!variantData || !variantData.length || !referenceOptions) return;
      const unavailableText = (options && options.unavailableText) || '';

      getOptionGroups(rootEl).forEach((group, index) => {
        const { exists, available } = this.validValuesForOption(variantData, referenceOptions, index);

        group.valueEls.forEach((el) => {
          // Combined-listing values map to other products, never filter them.
          if (el.dataset && el.dataset.productUrl) return;
          // The "select an option" placeholder is not a variant value.
          if (group.type === 'select' && el.value === '') return;

          const value = el.value;
          const variantExists = exists.has(value);
          const variantAvailable = available.has(value);

          if (group.type === 'select') {
            el.hidden = !variantExists;
            if (variantExists) {
              el.textContent = variantAvailable ? value : unavailableText.replace('[value]', value);
            }
          } else {
            const label = el.nextElementSibling;
            const isHidden = !variantExists;
            setRadioUnavailable(el, isHidden);
            if (label) label.classList.toggle('combo-hidden', isHidden);
            if (variantExists) {
              el.classList.toggle('disabled', !variantAvailable);
            }
          }
        });
      });
    }
  };
})();
